import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import posthog from 'posthog-js';

if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    ui_host: 'https://us.posthog.com',
    capture_pageview: false,
    loaded: (ph) => {
      if (process.env.NODE_ENV === 'development') ph.debug();
    },
  });
}

const analytics = Analytics({
  app: 'cruises-frontend',
  plugins: [
    {
      name: 'console-logger',
      page: ({ payload }) => {
        console.log('page view', payload);
      },
      track: ({ payload }) => {
        console.log('track event', { event: payload.event, ...payload.properties });
      },
      identify: ({ payload }) => {
        console.log('identify', payload);
      },
    },
    googleTagManager({
      containerId: 'GTM-N3XH75S',
    }),
    {
      name: 'posthog',
      page: ({ payload }) => {
        posthog.capture('$pageview', payload.properties);
      },
      track: ({ payload }) => {
        if (payload.event?.startsWith('browser.')) return;

        posthog.capture(payload.event, payload.properties);
      },
      identify: ({ payload }) => {
        posthog.identify(payload.userId, payload.traits);
      },
    },
    {
      name: 'gtm-custom',
      identify: ({ payload }) => {
        if (window.dataLayer) {
          window.dataLayer.push({ email: payload.userId });
        }
      },
    },
  ],
});

export default analytics;
